import { useEffect, useState } from "react";

// Content-hashed filename: the sprite is cached for a year (see server/index.ts),
// so this suffix MUST change any time public/assets/brand/partners-sprite.*.svg
// is regenerated, or returning visitors will keep the stale cached version.
const SPRITE_URL = "/assets/brand/partners-sprite.9b59a39e.svg";

let cachedMarkup: string | null = null;
let inflight: Promise<string> | null = null;

function loadSprite(): Promise<string> {
  if (cachedMarkup) return Promise.resolve(cachedMarkup);
  if (!inflight) {
    inflight = fetch(SPRITE_URL)
      .then((res) => res.text())
      .then((text) => {
        cachedMarkup = text;
        return text;
      })
      .catch(() => "");
  }
  return inflight;
}

/**
 * Injects the partner-logo SVG sprite into the DOM once, so every logo can
 * render as <use href="#logo-x"> instead of a separate <img> request — 26
 * network round trips collapse into this single (long-cached) fetch. Inlining
 * the fetched markup rather than pointing <use> at the external file directly
 * is required for Safari, which doesn't reliably resolve <use> references
 * into un-inlined external SVG documents.
 */
export default function PartnerLogoSprite() {
  const [markup, setMarkup] = useState<string | null>(cachedMarkup);

  useEffect(() => {
    if (markup) return;
    let cancelled = false;
    loadSprite().then((text) => {
      if (!cancelled) setMarkup(text);
    });
    return () => {
      cancelled = true;
    };
  }, [markup]);

  if (!markup) return null;
  return <div style={{ display: "none" }} dangerouslySetInnerHTML={{ __html: markup }} />;
}
